import { useQuery } from '@tanstack/react-query'

import { getTypedCreditBalances, REGULAR_CREDIT_TYPE, type TypedCreditBalance } from '@/lib/credits-api'
import { queryKeys } from '@/lib/query-keys'

// The RPC returns every active credit type; only show types the member actually holds.
// Kurs-Credits always stay visible as the default type.
function isRelevantCreditBalance(balance: TypedCreditBalance): boolean {
  return (
    balance.credit_type_id === REGULAR_CREDIT_TYPE ||
    Number(balance.available_balance_credits ?? 0) > 0 ||
    Boolean(balance.has_subscription_allowance) ||
    balance.has_unlimited_subscription ||
    Number(balance.available_subscription_credits ?? 0) > 0
  )
}

export function sortTypedCreditBalances(balances: TypedCreditBalance[]): TypedCreditBalance[] {
  return balances.filter(isRelevantCreditBalance).sort((a, b) => {
    if (a.credit_type_id === REGULAR_CREDIT_TYPE) return -1
    if (b.credit_type_id === REGULAR_CREDIT_TYPE) return 1
    return a.credit_name.localeCompare(b.credit_name, 'de')
  })
}

export function useTypedCreditBalances({
  weekStarts,
  userId,
  enabled = true,
}: {
  weekStarts: string[]
  userId?: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: queryKeys.typedCreditBalances(userId, weekStarts),
    queryFn: async () => sortTypedCreditBalances(await getTypedCreditBalances(weekStarts, userId)),
    enabled: enabled && weekStarts.length > 0,
    retry: false,
  })
}
